import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FixedTableModule } from 'Src/ng2/shared/components/list/fixed-table/fixed-table.module';
import { FixedToInfiniteViewModule } from 'Src/ng2/shared/components/list/fixed-to-infinite-view-container/fixed-to-infinite-view.module';
import { ListContainerModule } from 'Src/ng2/shared/components/list/list-container/list-container.module';
import { NvMatTooltipModule } from 'Src/ng2/shared/components/nv-mat-tooltip/nv-mat-tooltip.module';
import { SharedServicesModule } from 'Src/ng2/shared/services/shared.services.module';
import { ContentToolsModule } from 'Src/ng2/shell/content-tools/content-tools.module';
import { VizMadLibService } from '../mid-level-dashboard/viz-mad-lib/viz-mad-lib.service';
import { PageHeaderModule } from './../../shared/components/header/page-header/page-header.module';
import { StudentLevelDashComponent } from './student-level-dash.component';

@NgModule({
  imports: [
    CommonModule,
    ListContainerModule,
    FixedToInfiniteViewModule,
    FixedTableModule,
    ContentToolsModule,
    NvMatTooltipModule,
    PageHeaderModule,
    SharedServicesModule,
  ],
  declarations: [StudentLevelDashComponent],
  providers: [VizMadLibService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class StudentLevelDashModule {
  /** */
}
